var icon = require('vue-svgicon')
icon.register({
  'ks-icon-refresh': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M93.66 34.34a42 42 0 1 0 10.92 40.16H93.66A31.49 31.49 0 1 1 64 32.5a31.05 31.05 0 0 1 22.15 9.35l-16.9 16.9H106V22z"/>'
  }
})
